module.exports = __webpack_public_path__ + "static/media/PaddingAllsidesblack.6ee748c5.svg";